<template>
  <div>
    <div class="head_style_box">
      <div class="left" @click.stop="goBack">
        <img  class="img_style" src="@/assets/imgs/nav_icon_back.png" />
        <div class="title_style" style="font-weight: bold;">{{title}}</div>
      </div>
      <span class="right" v-if="isShow" @click="$emit('onFliter')">筛选</span>
    </div>
  </div>

</template>
<script>

export default {

  name: "Header",
  props: {
    title: String,
    isNav: {
      type: Boolean,
      default: false
    },
    isShow: {
      type: Boolean,
      default: false
    },
    isFilter: {
      type: Boolean,
      default: false
    },
    haveBg: {
      type: Boolean,
      default: false
    }
  },
  created() {
  },
  methods: {
    goBack() {
      this.$router.back();
    }
  }
};
</script>
<style lang="stylus" scoped>
.head_style_box {
  height: 112px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;

  .left {
    display: flex;
    align-items: flex-end;

    .img_style {
      width: 16px;
      height: 33px;
      margin-right: 32px;
    }

    .title_style {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 36px;
      color: #333333;
    }
  }

  .right {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 24px;
    color: #000000;
    line-height: 28px;
  }
}
</style>